import { SelectOpt } from '../../common/CommonTypes';
import { AddressDetails } from '../../common/address/FindAddress';
import { SelectInputHelper } from '../selectInput/SelectInput';

export type AddressSearchState = {
    showAddressList: boolean;
    showAddressForm: boolean;
    addressList: SelectOpt[];
    address: AddressDetails;
    selectedAddress: string;
    addressErrors: AddressDetails;
    finding: boolean;
    searchPostCode: string;
    searchPostCodeError: string;
    modal: boolean;
    lastSearchedPostCode: string;
    addressEditIndex: number;
    countries: SelectOpt[];
};

//Please add additional types with | 'your type'
type Action =
    | { type: 'set-show-address-list'; show: boolean }
    | { type: 'set-show-address-form'; show: boolean }
    | { type: 'set-address'; address: AddressDetails }
    | { type: 'set-selected-address'; moniker: string }
    | { type: 'set-address-errors'; errors: AddressDetails }
    | { type: 'set-finding'; finding: boolean }
    | { type: 'set-search-postcode'; postcode: string }
    | { type: 'set-search-postcode-error'; error: string }
    | { type: 'set-countries'; countries: SelectOpt[] }
    | { type: 'set-show-modal'; show: boolean }
    | { type: 'set-edit-modal'; editIndex: number; address: AddressDetails }
    | {
          type: 'load-addresses';
          addresses: SelectOpt[];
          show: boolean;
          error: string;
      };

const AddressManagerReducer = (
    state: AddressSearchState,
    action: Action
): AddressSearchState => {
    switch (action.type) {
        case 'set-show-address-list':
            return {
                ...state,
                showAddressList: action.show
            };
        case 'set-show-address-form':
            return {
                ...state,
                showAddressForm: action.show
            };
        case 'set-address':
            return {
                ...state,
                address: action.address
            };
        case 'set-selected-address':
            return {
                ...state,
                selectedAddress: action.moniker,
                addressErrors: {}
            };
        case 'set-address-errors':
            return {
                ...state,
                addressErrors: action.errors
            };
        case 'set-finding':
            return {
                ...state,
                finding: action.finding
            };
        case 'set-search-postcode':
            return {
                ...state,
                searchPostCode: action.postcode
            };
        case 'set-search-postcode-error':
            return {
                ...state,
                searchPostCodeError: action.error
            };
        case 'set-countries':
            return {
                ...state,
                countries: action.countries
            };
        case 'set-edit-modal':
            return {
                ...state,
                addressEditIndex: action.editIndex,
                modal: true,
                showAddressForm: true,
                showAddressList: false,
                searchPostCode: '',
                searchPostCodeError: '',
                lastSearchedPostCode: '',
                addressList: [],
                address: action.address
            };
        case 'set-show-modal':
            if (action.show) {
                return {
                    ...state,
                    modal: action.show,
                    showAddressList: false,
                    showAddressForm: false,
                    searchPostCode: '',
                    searchPostCodeError: '',
                    lastSearchedPostCode: '',
                    address: {},
                    addressErrors: {},
                    addressEditIndex: -1
                };
            } else {
                return {
                    ...state,
                    modal: action.show
                };
            }
        case 'load-addresses':
            return {
                ...state,
                addressList: action.addresses,
                selectedAddress: SelectInputHelper.NullValue(),
                showAddressList: action.show,
                showAddressForm: false,
                finding: false,
                searchPostCodeError: action.error,
                lastSearchedPostCode: state.searchPostCode
            };
        default:
            return state;
    }
};

export default AddressManagerReducer;
